const {makePDF} = require("../dynamic-modules/pdfMake");

module.exports = (list) => makePDF(({line, separator, exportLunuPDF}) => (
  exportLunuPDF(list.map((el) => {
    if (el.separator) return separator();
    const [title, value] = el;
    return line(title, value)
  })))
);